
const FutureReadySection = () => {
  return (
    <section className="relative py-40 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/371f90804a144268fa23c20d1eb2c67b.jpg"
          alt="Expansion Ready"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Glowing Orb */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-8">
          SCALABLE SOLUTIONS
        </span>
        
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-8">
          Expansion <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Ready</span>
        </h2>
        
        <p className="text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto mb-10">
          CruxOnAI's systems are built to scale into additional professional and service industries without rework or replatforming.
        </p>

        <a
          href="/contact"
          className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold rounded-lg hover:from-emerald-400 hover:to-teal-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-xl shadow-emerald-500/30 hover:shadow-emerald-500/50"
        >
          Discuss Your Industry
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>
    </section>
  );
};

export default FutureReadySection;
